// @flow
import Typography from "@mui/material/Typography";
import React from 'react';
import { useTranslation } from "react-i18next";
import { EXHIBITION } from "../../../../../../locales/components/namespaces";
import { Update } from "../../../../../../hooks/exhibitions/useExhibitionAction";
import { useDebouncedCallback } from "../../../../../../hooks/useDebouncedCallback";
import ListItemText from "@mui/material/ListItemText";
import { TextField } from "@mui/material";
import ListItem from "@mui/material/ListItem";

type Props = {};

const SendFromEmail = (props: Props) => {
	const { t } = useTranslation(EXHIBITION)
	const { id, exhibition, updateExhibition, exhibitionIsNotMainOfCoorg } = props
	const onChange = (value) => {
		updateExhibition(id, value, Update.SendFromEmail)
	}
	const { value, debouncedOnChange } = useDebouncedCallback(onChange, exhibition.sendFromEmail)
	return (
		<ListItem>
			<ListItemText
				primary={t("Sender Email")}
				secondary={
					<React.Fragment>
						{t("Use alternative email to send emails. If field remains empty, default email will be used. Email domain must be declared in Mailchimp services.")}
						{exhibitionIsNotMainOfCoorg && (
							<React.Fragment>
								<br/>
								<Typography
									variant={'body2'}
									component={'span'}
									color={'error'}
								>
									{t('This exhibition is part of a coorganization and not the main coorganization exhibition. As such, Sender Email Settings are note applied in Registration Form. For Registration Form visit main coorganization exhibition settings.')}
								</Typography>
							</React.Fragment>
						)}
					</React.Fragment>
				}
			/>
			<TextField
				defaultValue={value}
				onChange={debouncedOnChange}
				size={"small"}
				fullWidth
				variant={'filled'}
				sx={{ minWidth: '200px' }}
				slotProps={{
					htmlInput: {
						maxLength: 250,
						inputMode: 'text'
					},
				}}
			/>
		</ListItem>
	);
};

export default SendFromEmail